import type { RegionWithRequiredFields } from "../../types";

export const getRegionFromRegionCode = (
  regionCode: string | undefined,
  regions: RegionWithRequiredFields[]
): RegionWithRequiredFields | undefined => regions.find((region) => region.code === regionCode);
